var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCmEn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2958 52.9395L42 54.6437L32.7042 52.9395L35.183 45.0905L42.2346 42.2896L48.817 45.0905L51.2958 52.9395Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2112 57.9497L41.0445 60.3022L26.7886 57.9497V54.1087C26.7886 53.463 27.3184 52.9397 27.9717 52.9397H56.028C56.6815 52.9397 57.2111 53.4631 57.2111 54.1087V57.9497H57.2112Z",
    fill: "#E23232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4647 82.9999H8.78866L3.5572 82.423C2.15709 82.423 1.02194 81.3015 1.02194 79.9179L1.11743 60.9937C1.11743 59.6103 2.25241 58.4886 3.65268 58.4886L8.78866 57.9495H81.4647C82.8648 57.9495 84 59.0709 84 60.4545V80.4948C84 81.8784 82.865 82.9999 81.4647 82.9999Z",
    fill: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78866 57.9497V83H2.53526C1.1358 83 0 81.8777 0 80.4949V60.4548C0 59.072 1.1358 57.9497 2.53526 57.9497H8.78866Z",
    fill: "#E23232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8028 45.0906H13.6057L9.37945 44.0051C7.97934 44.0051 6.84419 42.8836 6.84419 41.5L7.09865 3.12093C7.09865 1.73749 8.23364 0.615854 9.63391 0.615854L13.6057 0H75.8029C77.203 0 78.3382 1.12147 78.3382 2.50508V42.5855C78.338 43.9689 77.2031 45.0906 75.8028 45.0906Z",
    fill: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6057 0V45.0906H8.19722C6.79777 45.0906 5.66196 43.9683 5.66196 42.5855V2.50508C5.66196 1.12228 6.79777 0 8.19722 0L13.6057 0Z",
    fill: "#E23232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2675 35.0704V39.7464C73.2675 39.9309 73.1163 40.0804 72.9296 40.0804H13.6057L11.6045 39.5114C11.4178 39.5114 11.2665 39.3619 11.2665 39.1774L10.7325 35.0704L40.0903 32.8589L73.2675 35.0704Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2675 5.34412V35.0704H11.4891L11.3618 6.20151C11.3618 6.01703 11.5131 5.86757 11.6998 5.86757L13.6055 5.01001H72.9296C73.1163 5.01001 73.2675 5.15964 73.2675 5.34412Z",
    fill: "#B84B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6057 35.0705V40.0805H11.0704C10.8846 40.0805 10.7325 39.9302 10.7325 39.7466V35.0705L12.1692 33.9907L13.6057 35.0705Z",
    fill: "#FF1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6057 5.01001V35.0704H10.7323V5.34412C10.7323 5.16045 10.8844 5.01017 11.0703 5.01017L13.6057 5.01001Z",
    fill: "#FFC0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5915 77.9901H8.78866L6.14414 77.5605C5.95744 77.5605 5.80617 77.411 5.80617 77.2266L5.53973 63.6032C5.53973 63.4187 5.691 63.2693 5.8777 63.2693L8.78866 62.96H78.5915C78.7782 62.96 78.9295 63.1094 78.9295 63.2939V77.6561C78.9297 77.8405 78.7782 77.9901 78.5915 77.9901Z",
    fill: "#E23232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78867 62.9597V77.9899H5.40849C5.2226 77.9899 5.07052 77.8396 5.07052 77.6559V63.2937C5.07052 63.11 5.2226 62.9597 5.40849 62.9597H8.78867Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 73.3973C43.6335 73.3973 44.9577 72.0888 44.9577 70.4748C44.9577 68.8607 43.6335 67.5522 42 67.5522C40.3665 67.5522 39.0423 68.8607 39.0423 70.4748C39.0423 72.0888 40.3665 73.3973 42 73.3973Z",
    fill: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9296 24.8V28.641C66.9296 28.7333 66.854 28.808 66.7606 28.808H62.8733C62.78 28.808 62.7044 28.7333 62.7044 28.641V24.8C62.7044 24.7078 62.78 24.6331 62.8733 24.6331H66.7606C66.8538 24.6331 66.9296 24.7078 66.9296 24.8Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1689 24.8V28.641C60.1689 28.7333 60.0933 28.808 60 28.808H56.1127C56.0193 28.808 55.9437 28.7333 55.9437 28.641V24.8C55.9437 24.7078 56.0193 24.6331 56.1127 24.6331H60C60.0933 24.6331 60.1689 24.7078 60.1689 24.8Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 24.8V28.641C53.4084 28.7333 53.3328 28.808 53.2394 28.808H49.3521C49.2588 28.808 49.1832 28.7333 49.1832 28.641V24.8C49.1832 24.7078 49.2588 24.6331 49.3521 24.6331H53.2394C53.3328 24.6331 53.4084 24.7078 53.4084 24.8Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1689 18.1199V21.9609C60.1689 22.0531 60.0933 22.1278 60 22.1278H56.1127C56.0193 22.1278 55.9437 22.0531 55.9437 21.9609V18.1199C55.9437 18.0276 56.0193 17.9529 56.1127 17.9529H60C60.0933 17.9527 60.1689 18.0276 60.1689 18.1199Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 18.1199V21.9609C53.4084 22.0531 53.3328 22.1278 53.2394 22.1278H49.3521C49.2588 22.1278 49.1832 22.0531 49.1832 21.9609V18.1199C49.1832 18.0276 49.2588 17.9529 49.3521 17.9529H53.2394C53.3328 17.9527 53.4084 18.0276 53.4084 18.1199Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9296 18.1199V21.9609C66.9296 22.0531 66.854 22.1278 66.7606 22.1278H62.8733C62.78 22.1278 62.7044 22.0531 62.7044 21.9609V18.1199C62.7044 18.0276 62.78 17.9529 62.8733 17.9529H66.7606C66.8538 17.9527 66.9296 18.0276 66.9296 18.1199Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9296 11.4397V15.2807C66.9296 15.3729 66.854 15.4477 66.7606 15.4477H62.8733C62.78 15.4477 62.7044 15.3729 62.7044 15.2807V11.4397C62.7044 11.3474 62.78 11.2727 62.8733 11.2727H66.7606C66.8538 11.2727 66.9296 11.3474 66.9296 11.4397Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1689 11.4397V15.2807C60.1689 15.3729 60.0933 15.4477 60 15.4477H56.1127C56.0193 15.4477 55.9437 15.3729 55.9437 15.2807V11.4397C55.9437 11.3474 56.0193 11.2727 56.1127 11.2727H60C60.0933 11.2727 60.1689 11.3474 60.1689 11.4397Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4084 11.4397V15.2807C53.4084 15.3729 53.3328 15.4477 53.2394 15.4477H49.3521C49.2588 15.4477 49.1832 15.3729 49.1832 15.2807V11.4397C49.1832 11.3474 49.2588 11.2727 49.3521 11.2727H53.2394C53.3328 11.2727 53.4084 11.3474 53.4084 11.4397Z",
    fill: "#FF8484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2535 20.5412H16.2253C15.9452 20.5412 15.7182 20.3169 15.7182 20.0402V10.5211C15.7182 10.2444 15.9452 10.02 16.2253 10.02H42.2535C42.5335 10.02 42.7606 10.2444 42.7606 10.5211V20.0402C42.7606 20.317 42.5335 20.5412 42.2535 20.5412Z",
    fill: "#FFC0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9578 30.0604H18C16.7398 30.0604 15.7183 29.051 15.7183 27.806C15.7183 26.5608 16.74 25.5515 18 25.5515H26.9578C28.2179 25.5515 29.2394 26.561 29.2394 27.806C29.2394 29.051 28.2179 30.0604 26.9578 30.0604Z",
    fill: "#FF8989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4788 30.0604H36.5915C35.3314 30.0604 34.3099 29.051 34.3099 27.806C34.3099 26.5608 35.3315 25.5515 36.5915 25.5515H40.4788C41.739 25.5515 42.7604 26.561 42.7604 27.806C42.7606 29.051 41.739 30.0604 40.4788 30.0604Z",
    fill: "#FF8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6901 16.5332H20.7887C20.0885 16.5332 19.5211 15.9725 19.5211 15.2808C19.5211 14.5891 20.0886 14.0283 20.7887 14.0283H37.6901C38.3903 14.0283 38.9576 14.5891 38.9576 15.2808C38.9578 15.9725 38.3903 16.5332 37.6901 16.5332Z",
    fill: "#B84B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 83,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCmEn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cm_en.45d6029d.svg";
export { ForwardRef as ReactComponent };